import $ from "jquery";
import Vue from "vue";
import router from "./routes";
import VueModal from "vue-js-modal";

Vue.use(VueModal, {
    dynamic: true,
    injectModalsContainer: true
});

import NavBarComponent from "./components/NavBar";
import MenuComponent from "./components/Menu";
import NewsComponent from "./components/News";

Vue.component('news', NewsComponent);

router.afterEach((to, from) => {
    $("html").removeClass("opened");
});

new Vue({
    el: '#app',
    router,
    components: {
        navbar: NavBarComponent,
        "top-menu": MenuComponent
    },
    data() {
        return {
            showHeader: true
        };
    },
    methods: {
        navBarClick() {
            $("html").toggleClass("opened");
        },
        header(enabled) {
            this.showHeader = enabled;
        }
    }
});